import React, {useEffect, useMemo, useState, useRef} from 'react';
import B2BApiService from "../../B2bApiService";
import GeneralSettings from "./GeneralSettings";
import SecuritySettings from './SecuritySettings';

import * as Constants from "../../constants";

import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import cog from "../../assets/images/icons/cog.svg"
import editIcon from "../../assets/images/icons/editIcon.png"
import { t } from "../../content";

export default function Settings() {
  
  const [userRole, setUserRole] = useState(null);

  const hasFetchedRef = useRef(false);

  const b2bServiceObj = useMemo(() => {
    return new B2BApiService();
  }, []);

  useEffect(() => {
    // Fetch current logged in user data again to make sure we have the latest user role and info
    b2bServiceObj.LoadUserData((userData) => {
      localStorage.setItem(Constants.LOCAL_STORAGE_KEY_USER_ROLE_ID, userData.userRole)
      setUserRole(userData.userRole);
    })

    // Fetch all corporate users of the company. Only Owner, Admin and HRD can access this API
    if (userRole && [...Constants.ADMINISTRATIVE_USER_ROLES, Constants.USER_ROLE_HRD].includes(userRole)) {
      if (hasFetchedRef.current) return; // Make sure we only fetch once
      hasFetchedRef.current = true;
      b2bServiceObj.GetCompanyAccounts();
    }

  }, [b2bServiceObj, userRole]);

  return (
    <>
      <div className='page-layout-wrapper'>
        <div className='inner-layout'>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <Row className='w-100'>
        <Col sm={12} className='d-flex vp-1200'>
          <div>
            <Nav variant="pills" className="flex-column bg-white py-3 px-2 mb-3 rounded" style={{width: "300px"}}>
              <strong className='m-2'>
                {t('nav.items.accountSettings')}
              </strong>
              <hr style={{ margin: '0px 0px 10px 0px' }} />
              <Nav.Item>
                <Nav.Link eventKey="first"> <img className='m-2' src={cog} alt='account settings'/> {t('account.nav.account')} </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second"> <img height="20px" className='m-2' src={editIcon} alt='change-password'/> {t('account.nav.security')}</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Tab.Content className='w-100'>
            <Tab.Pane eventKey="first"><GeneralSettings userRole={userRole} /></Tab.Pane>
            <Tab.Pane eventKey="second"><SecuritySettings userRole={userRole} /></Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
        </div>
      </div>
    </>
  );
}
